import { Button, Typography } from "@mui/material";
import Box from "@mui/material/Box/Box";
import styled from "styled-components";

type InfoCardButtonProps = {
  customtextcolor?: string;
};

export const Container = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 0 12px;
`;

export const Wrapper = styled(Box)`
  max-width: 500px;
  width: 100%;
  height: fit-content;
  flex-shrink: 0;
  border-radius: 10px 10px 10px 10px;
  background: #f4f4f4;
`;

export const Header = styled(Box)`
  width: 100%;
  position: relative;
  height: 48px;
  flex-shrink: 0;
  border-radius: 10px 10px 0px 0px;
  background-color: #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 5px;
  cursor: pointer;
`;

export const TitleWrapper = styled(Box)`
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
`;

export const CardTitle = styled(Typography)`
  color: #1d1d1d;
  text-align: center;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const CardTexts = styled(Typography)`
  color: #1d1d1d;
  text-align: center;
  font-family: "NotoSans-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

export const Content = styled(Box)`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  gap: 10px;
  padding: 10px 18px 5px 18px;
  border-radius: 0px 0px 10px 10px;
  background: var(--colours-primary-white, #fff);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
`;

export const Info = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const FeesInfoWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 18px;
`;

export const FeesAndCurrencyWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const GameFullWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const GameFullTypography = styled(Typography)`
  color: #898a8d;
  font-family: "NotoSans-Medium";
  font-size: 16px !important;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const ActionWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const BtnWrapper = styled(Box)`
  display: flex;
  width: 100%;
  cursor: pointer;
`;

export const Footer = styled(Box)`
  width: 100%;
  margin-top: 10px;
`;

export const FooterWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
  gap: 10px;
  cursor: pointer;
`;

export const InfoCardButton = styled(Button)<InfoCardButtonProps>`
  display: flex;
  height: 32px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  color: ${(props) =>
    props.customtextcolor || "var(--colours-teal-600, #129479)"};
  font-size: 16px;
  font-family: "Outfit-SemiBold";
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  flex: 1 0 0;
  border-radius: 6px;
  border: 2px solid var(--colours-teal-600, #129479);
  text-transform: none;
`;

export const GameDetailTypography = styled(Typography)`
  color: rgba(0, 0, 0, 0.41);
  font-family: "NotoSans-SemiBold";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;

export const DetailFooterWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const InfoWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
`;

export const EditIconWrapper = styled(Box)`
  position: absolute;
  right: 40px;
  cursor: pointer;
`;

export const ShareIconWrapper = styled(Box)`
  position: absolute;
  right: 10px;
  cursor: pointer;
`;

export const CurrencyWrapper = styled(Box)<{ isPound: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: ${(props) => (props.isPound ? "row-reverse" : "row")};
`;

export const AddToCalendarBtnWrapper = styled(Box)`
  position: absolute;
  left: 0;
  margin-left: -15px;
`;
